module.exports = __webpack_public_path__ + "img/insan_vucudu.1707d434.jpg";